import { RangeSelectorOptions } from 'highcharts';

export const rangeSelector5Meses: RangeSelectorOptions = {
	enabled: true,
	y: 20,
	buttons: [
		{
			type: 'month',
			count: 1,
			text: '1m',
		},
		{
			type: 'month',
			count: 2,
			text: '2m',
		},
		{
			type: 'month',
			count: 3,
			text: '3m',
		},
		{
			type: 'month',
			count: 4,
			text: '4m',
		},
		{
			type: 'month',
			count: 5,
			text: '5m',
		},
		{
			type: 'all',
			text: 'Todo',
		},
	],
};

export const rangeSelector5Dias: RangeSelectorOptions = {
	enabled: true,
	y: 20,
	buttons: [
		{
			type: 'day',
			count: 1,
			text: '1d',
		},
		{
			type: 'day',
			count: 2,
			text: '2d',
		},
		{
			type: 'day',
			count: 3,
			text: '3d',
		},
		{
			type: 'day',
			count: 4,
			text: '4d',
		},
		{
			type: 'day',
			count: 5,
			text: '5d',
		},
		{
			type: 'all',
			text: 'Todo',
		},
	],
};

export const rangeSelector5Horas: RangeSelectorOptions = {
	enabled: true,
	y: 20,
	buttons: [
		{
			type: 'hour',
			count: 1,
			text: '1h',
		},
		{
			type: 'hour',
			count: 2,
			text: '2h',
		},
		{
			type: 'hour',
			count: 3,
			text: '3h',
		},
		{
			type: 'hour',
			count: 4,
			text: '4h',
		},
		{
			type: 'hour',
			count: 5,
			text: '5h',
		},
		{
			type: 'all',
			text: 'Todo',
		},
	],
};
